import { section } from '@/neon';

const selectors = {
  recoverPasswordLink: '#RecoverPassword',
  recoverPasswordForm: '#RecoverPasswordForm',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  customerLoginForm: '#CustomerLoginForm',
  resetFormState: '.reset-password-success',
  resetFormMessage: '#ResetSuccess',
};

section('login', {
  onLoad() {
    this.recoverPasswordLink = this.container.querySelector(
      selectors.recoverPasswordLink
    );
    this.hideRecoverPasswordLink = this.container.querySelector(
      selectors.hideRecoverPasswordLink
    );
    this.customerLoginForm = this.container.querySelector(
      selectors.customerLoginForm
    );

    this._onShowHidePasswordForm = this._onShowHidePasswordForm.bind(this);

    if (this.recoverPasswordLink) {
      this._checkUrlHash();
      this._resetPasswordSuccess();

      this.recoverPasswordLink.addEventListener(
        'click',
        this._onShowHidePasswordForm
      );
      this.hideRecoverPasswordLink.addEventListener(
        'click',
        this._onShowHidePasswordForm
      );
    }
  },

  _onShowHidePasswordForm(evt) {
    evt.preventDefault();
    this._toggleRecoverPasswordForm();
  },

  _checkUrlHash() {
    const hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      this._toggleRecoverPasswordForm();
    }
  },

  /**
   *  Show/Hide recover password form
   */
  _toggleRecoverPasswordForm() {
    const recoverPasswordForm = this.container.querySelector(
      selectors.recoverPasswordForm
    );

    recoverPasswordForm.classList.toggle('hide');
    this.customerLoginForm.classList.toggle('hide');
  },

  /**
   *  Show reset password success message
   */
  _resetPasswordSuccess() {
    const formState = this.container.querySelector(selectors.resetFormState);
    const formMessage = this.container.querySelector(
      selectors.resetFormMessage
    );

    // check if reset password form was successfully submited.
    if (!formState) {
      return;
    }

    // show success message
    formMessage.classList.remove('hide');
  },

  onUnload() {},
});
